<div class="table-mobile-card-list">
  <app-loading-state
    *ngIf="isLoading && !hasData"
    message="Obteniendo datos..."
    [spinnerDiameter]="40">
  </app-loading-state>

  <app-empty-state
    *ngIf="!isLoading && !hasData"
    icon="inbox"
    [title]="noDataMessage"
    description="No hay registros que mostrar en este momento">
  </app-empty-state>

  <div class="table-mobile-card-list__cards" *ngIf="hasData">
    <article
      *ngFor="let row of rows; trackBy: trackByRow"
      class="table-mobile-card"
      [class.table-mobile-card--custom]="!!cardTemplate"
      [class.table-mobile-card--clickable]="enableRowHover"
      [attr.role]="cardTemplate ? null : 'button'"
      [attr.tabindex]="cardTemplate ? null : 0"
      (click)="onRowClick(row)"
      (keyup.enter)="onRowClick(row)">
      <ng-container *ngIf="cardTemplate; else defaultCard">
        <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: row, row: row }"></ng-container>
      </ng-container>
      <ng-template #defaultCard>
      <header class="table-mobile-card__header" *ngIf="titleColumn as title">
        <ng-container *ngIf="cellTemplate; else titleFallback">
          <ng-container *ngTemplateOutlet="cellTemplate; context: { column: title.key, row: row, view: 'card' }"></ng-container>
        </ng-container>
        <ng-template #titleFallback>{{ getFallbackValue(row, title) }}</ng-template>
      </header>

      <dl class="table-mobile-card__details">
        <div
          class="table-mobile-card__field"
          *ngFor="let column of detailColumns; trackBy: trackByColumn">
          <dt>{{ getColumnLabel(column) }}</dt>
          <dd>
            <ng-container *ngIf="cellTemplate; else valueFallback">
              <ng-container *ngTemplateOutlet="cellTemplate; context: { column: column.key, row: row, view: 'card' }"></ng-container>
            </ng-container>
            <ng-template #valueFallback>{{ getFallbackValue(row, column) }}</ng-template>
          </dd>
        </div>
      </dl>
      </ng-template>
      <div *ngIf="rowDetailTemplate && row === expandedRow" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="rowDetailTemplate; context: { row: row, view: 'card' }"></ng-container>
      </div>
    </article>
  </div>

  <mat-progress-spinner
    *ngIf="isLoading && hasData"
    class="table-mobile-card-list__overlay-spinner"
    diameter="28"
    mode="indeterminate">
  </mat-progress-spinner>

  <div
    *ngIf="!errorMessage && paginationConfig && paginationConfig.totalCount > 0"
    class="table-mobile-pagination">
    <button
      mat-icon-button
      [disabled]="isFirstPage || isLoading"
      (click)="previousPage()"
      matTooltip="Pagina anterior">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="table-mobile-pagination__indicator">
      Página {{ paginationConfig.currentPage }} de {{ paginationConfig.totalPages }}
    </span>
    <button
      mat-icon-button
      [disabled]="isLastPage || isLoading"
      (click)="nextPage()"
      matTooltip="Pagina siguiente">
      <mat-icon>chevron_right</mat-icon>
    </button>

    <label
      *ngIf="showPageSizeSelector && pageSizeOptions && pageSizeOptions.length > 0"
      class="table-mobile-pagination__size">
      <span>Por página:</span>
      <select
        [disabled]="isLoading"
        class="table-mobile-pagination__select"
        (change)="onPageSizeChange($event)">
        <option
          *ngFor="let size of pageSizeOptions"
          [value]="size"
          [selected]="size === selectedPageSize">
          {{ size }}
        </option>
      </select>
    </label>
  </div>
</div>
